import { t } from "ttag";
import _ from "underscore";

/* CIQ Edit */
import {
  // PERSONAL_COLLECTION, /* CIQ Edit: remove since it's not used anymore */
  // PERSONAL_COLLECTIONS, /* CIQ Edit: remove since it's not used anymore */
  ROOT_COLLECTION,
} from "./constants";
import { omitPersonalCollections } from "./getInitialCollectionId";

// given list of collections with { id, name, location } returns a map of ids to
// expanded collection objects like { id, name, location, path, children }
// including a root collection
function getExpandedCollectionsById(
  collections,
  userPersonalCollectionId,
  collectionFilter = () => true,
) {
  const collectionsById = {};

  // CIQ EDIT: I'm not sure if personal collections are lazily generated
  // so its best to just filter out personal collections here
  const nonPersonalCollections = omitPersonalCollections(collections);
  for (const c of nonPersonalCollections) {
    collectionsById[c.id] = {
      ...c,
      path:
        c.id === "root"
          ? []
          : c.location != null
            ? ["root", ...c.location.split("/").filter((l) => l)]
            : null,
      parent: null,
      children: [],
    };
  }

  // "Our Analytics"
  collectionsById[ROOT_COLLECTION.id] = {
    ...ROOT_COLLECTION,
    name: collectionsById[ROOT_COLLECTION.id]
      ? ROOT_COLLECTION.name
      : t`Collections`,
    parent: null,
    children: [],
    ...(collectionsById[ROOT_COLLECTION.id] || {}),
  };

  // CIQ Edit: Remove "My personal collection" - personal collections disabled
  // if (
  //   userPersonalCollectionId != null &&
  //   !!collectionsById[userPersonalCollectionId]
  // ) {
  //   const personalCollection = collectionsById[userPersonalCollectionId];
  //   collectionsById[ROOT_COLLECTION.id].children.push({
  //     ...PERSONAL_COLLECTION,
  //     id: userPersonalCollectionId,
  //     parent: collectionsById[ROOT_COLLECTION.id],
  //     children: personalCollection?.children || [],
  //   });
  // }

  // CIQ Edit: Remove "Personal Collections" - personal collections disabled
  // collectionsById[PERSONAL_COLLECTIONS.id] = {
  //   ...PERSONAL_COLLECTIONS,
  //   parent: collectionsById[ROOT_COLLECTION.id],
  //   children: [],
  // };
  // collectionsById[ROOT_COLLECTION.id].children.push(
  //   collectionsById[PERSONAL_COLLECTIONS.id],
  // );

  // iterate over original collections so we don't include ROOT_COLLECTION as
  // a child of itself
  /* CIQ Edit: collections -> nonPersonalCollections */
  for (const { id } of nonPersonalCollections) {
    const c = collectionsById[id];
    // don't add root as parent of itself
    if (c.path && c.id !== ROOT_COLLECTION.id) {
      let parentId;
      // CIQ Edit: Skip personal collections entirely
      if (c.personal_owner_id != null) {
        continue; // Skip personal collections
      } else {
        // Find the closest parent that the user has permissions for
        const parentIdIndex = _.findLastIndex(
          c.path,
          (p) => collectionsById[p],
        );
        parentId = parentIdIndex >= 0 ? c.path[parentIdIndex] : undefined;
      }
      if (!parentId) {
        parentId = ROOT_COLLECTION.id;
      }

      const parent = parentId == null ? null : collectionsById[parentId];
      c.parent = parent;
      // need to ensure the parent collection exists, it may have been filtered
      // because we're selecting a collection's parent collection and it can't
      // contain itself
      if (parent) {
        parent.children.push(c);
      }
    }
  }

  // CIQ Edit: Cleanup logic not needed since we don't create PERSONAL_COLLECTIONS
  // remove PERSONAL_COLLECTIONS collection if there are none or just one (the user's own)
  // if (collectionsById[PERSONAL_COLLECTIONS.id].children.length <= 1) {
  //   delete collectionsById[PERSONAL_COLLECTIONS.id];
  //   collectionsById[ROOT_COLLECTION.id].children = collectionsById[
  //     ROOT_COLLECTION.id
  //   ].children.filter((c) => c.id !== PERSONAL_COLLECTIONS.id);
  // }

  return collectionsById;
}

export default getExpandedCollectionsById;
